<div class="row">
  <div class="col col-xs-12 col-sm-12">
    <div *ngIf="showVorversicherungGroup">
      <div class="input_radio">
        <app-label [control]="vorversicherung" for="vorversicherung">{{ expertMode ? 'Wurde schon einmal eine ' + versicherungsArt + ' abgeschlossen?' : 'Hatten Sie schon einmal eine ' + versicherungsArt + '?' }}</app-label>
        <mat-radio-group id="vorversicherung" [formControl]="vorversicherung">
          <mat-radio-button value="ja">Ja</mat-radio-button>
          <mat-radio-button value="nein">Nein</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="vorversicherung.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </div>
    </div>
    <app-vorversicherung #_vorversicherung [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="vorversicherungGroup" [showGroup]="showVorversicherungFelder" [expertMode]="expertMode"></app-vorversicherung>
  </div>
  <div class="col col-xs-12 col-sm-12">
    <div class="input_radio">
      <app-label [control]="kuendigungRisiken" for="kuendigungRisiken">{{ expertMode ? 'Wurde die Versicherung der beantragten Risiken bereits gekündigt, abgelehnt oder einvernehmlich gelöst?' : 'Wurde Ihnen bereits die Versicherung der beantragten Risiken gekündigt, abgelehnt oder einvernehmlich gelöst?' }}</app-label>
      <mat-radio-group id="kuendigungRisiken" [formControl]="kuendigungRisiken">
        <mat-radio-button value="ja">Ja</mat-radio-button>
        <mat-radio-button value="nein">Nein</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="kuendigungRisiken.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
  </div>
  <div class="col col-xs-12 col-sm-12">
    <p class="red-error-text-circle" *ngIf="showKuendigungRisikenGroup">Beachten Sie bitte, dass HDI Anträge mit einem Sonderrisiko nur in bestimmten Fällen und nach eingehender Prüfung annimmt.</p>
    <app-vorversicherung #_gekuendigteVorversicherung [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="gekuendigteVorversicherungGroup" [showGroup]="showGekuendigteVorversicherungFelder" [expertMode]="expertMode" id="_gekuendigteVorversicherung"></app-vorversicherung>
    <div class="row">
      <div class="col col-xs-12 col-sm-6">
        <div class="input" *ngIf="showKuendigungRisikenGroup">
          <app-label [control]="datumKuendigung" class="input-date-picker__label" for="datumKuendigung">Datum der Kündigung/Ablehnung:</app-label>
          <mat-form-field>
            <input matInput id="datumKuendigung" [matDatepicker]="datumKuendigungPicker" [max]="maxDate" placeholder="TT.MM.JJJJ" [formControl]="datumKuendigung">
            <mat-datepicker-toggle matSuffix [for]="datumKuendigungPicker"></mat-datepicker-toggle>
            <mat-datepicker #datumKuendigungPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-6">
        <div class="input" *ngIf="showKuendigungRisikenGroup">
          <app-label [control]="grundKuendigung" class="input__label" for="grundKuendigung">Grund der Kündigung/Ablehnung:</app-label>
          <mat-form-field>
            <input matInput id="grundKuendigung" [formControl]="grundKuendigung">
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="col col-xs-12 col-sm-12">
    <div class="mb-3" *ngIf="!showKuendigungRisikenGroup && kuendigungRisiken.value === 'ja'">
      <div class="custom-select__label red-error-text-circle">Eine bereits gekündigte, abgelehnte oder einvernehmlich gelöste Versicherung stellt ein anfragepflichtiges Sonderrisiko dar.
        <span [innerHTML]="(expertMode? translateService.get('SPEZIELLEANFRAGEEXPERT')  : translateService.get('SPEZIELLEANFRAGE'))|async"></span>
        <span class="info">
          <span class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ANNAHMERICHTLINIENINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></span>
        </span>
      </div>
    </div>
  </div>
</div>

